import { render, staticRenderFns } from "./Ephemera.vue?vue&type=template&id=d60a323e&"
import script from "./Ephemera.vue?vue&type=script&lang=js&"
export * from "./Ephemera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports